import { ServerClass } from 'interfaces/class'
import { http } from '@/api/httpAxios'

function getDateSchedule(day?: string) {
  let params = undefined
  if (day) {
    params = new URLSearchParams([['date', day]])
  }

  return http.get<ServerClass[]>('/schedule/check-in', { params })
}

function getWeekSchedule() {
  return http.get<ServerClass[]>('/schedule/check-in')
}

export const StudentClassesApi = {
  getDateSchedule,
  getWeekSchedule
}
